import React from 'react'
import useSeti from '../components/CustomHooks/useSeti'
import OpenTripsWithPrepopLink, {
  OpenTripsLinkProps
} from '../components/Packages/OpenTripsWithPrepopLink'

const AddAnotherHotelExperiment = (props: OpenTripsLinkProps) => {
  const isNewHotelLanding =
    useSeti('PKG_ADDITIONAL_HOTEL_LINK_NEW_HOTEL_LANDING') !== 'DEFAULT'

  return isNewHotelLanding ? <OpenTripsWithPrepopLink {...props} /> : null
}

export default AddAnotherHotelExperiment
